import React from "react";
import { Box, Typography, IconButton, Divider, Link } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Tag from "../Tag";

const DeploymentRoleCategoryCard = ({
  roleCategory = "[Role Category]",
  company = "[Company Name]",
  location = "Irvine, CA",
  years = "[Year Range]",
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  projects = [],
  onEdit,
  onDelete,
  node
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        padding: "8px 16px 16px 16px",
        flexDirection: "column",
        alignItems: "flex-start",

        borderRadius: "6px",
        border: "1px solid var(--SMA-sys-light-outline-variant, #D6C1CB)",
        backgroundColor: "#FFF",
        boxShadow:
          "0 1px 2px 0 rgba(0,0,0,0.30), 0 1px 3px 1px rgba(0,0,0,0.15)",
          ...node?.style,
          height:"fit-content",

      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: "8px 0",
          justifyContent: "space-between",
          alignItems: "flex-start",
          alignContent: "flex-start",

          alignSelf: "stretch",
          flexWrap: "wrap",
          alignItems: "center", 
        }}
      >
        <Typography
          sx={{
            color: "#21191E",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "24px",
            letterSpacing: "0.15px",
            ...node?.lbl1?.style,
          }}
        >
          {node?.lbl1?.label || roleCategory}
        </Typography>

        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" aria-label="delete" onClick={onDelete}>
            <DeleteOutlineIcon sx={{ fontSize: 24 }} />
          </IconButton>
          <IconButton size="small" aria-label="edit" onClick={onEdit}>
            <EditOutlinedIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Box>
      </Box>

   
        <Typography
          sx={{
            color: "#21191E",
            fontFamily: "Roboto",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0.25px",
            ...node?.lbl2?.style,
          }}
        >
        {node?.lbl2?.label || description}
        </Typography>
    
      <Box display="flex" gap={"8px"} alignItems="center" mt="12px">
        <Typography sx={{ ...node?.lbl3?.style }}>{node?.lbl3?.label || "Roles:"}</Typography>
        <Box display="flex" flexWrap="wrap" gap={"8px"} alignItems="center">
          {Array.from({ length: 5 }).map((_, index) => (
            <Tag
              key={index}
              label={node?.lbl4?.label || `Role ${index + 1}`}
              style={{
                display: "flex",
                padding: "4px 8px",
                alignItems: "center",
                gap: "10px",
                borderRadius: "4px",
                border:
                  "1px solid var(--sma-state-layers-light-on-surface-opacity-012, rgba(33, 25, 30, 0.12))",
                background:
                  "var(--sma-state-layers-light-on-surface-opacity-008, rgba(33, 25, 30, 0.08))",
                  ...node?.lbl4?.style,
              }}
            />
          ))}
        </Box>
      </Box>
      <Box
   
   mt="16px"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          alignContent: "flex-start",
          gap: "16px",
          alignSelf: "stretch",
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography
            sx={{
              color: "var(--SMA-sys-light-on-surface, #21191E)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
              letterSpacing: "0.1px",
                ...node?.str1?.style,
            }}
          >
            {node?.str1?.label || "Optimal Pay Rate"}
          </Typography>
          <Typography
            sx={{
              color: "var(--SMA-sys-light-on-surface, #21191E)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              letterSpacing: "0.25px",
                ...node?.lbl5?.style,
            }}
          >
            {node?.lbl5?.label || "$100/hr"}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              color: "var(--SMA-sys-light-on-surface, #21191E)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
              letterSpacing: "0.1px",
              ...node?.str2?.style,
            }}
          >
           {node?.str2?.label || "Expected Years of Experience (YOE)"}
          </Typography>
          <Typography
            sx={{
              color: "var(--SMA-sys-light-on-surface, #21191E)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              letterSpacing: "0.25px",
            }}
          >
            10 years
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              color: "var(--SMA-sys-light-on-surface, #21191E)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
              letterSpacing: "0.1px",
              ...node?.str3?.style,
            }}
          >
            {node?.str3?.label || "Months of Project History Needed"}
          </Typography>
          <Typography
            sx={{
              color: "var(--SMA-sys-light-on-surface, #21191E)",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              letterSpacing: "0.25px",
            }}
          >
            33
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DeploymentRoleCategoryCard;
